import React from 'react';

import { DetailAbout } from '../../../../assets/img/svg/details';
import image from "../../../../../src/assets/img/estudantes-2.webp";
import maskImage from "../../../../../src/assets/img/about-mask.webp";

const FeiraProfissoes: React.FC<{content: string}> = ({content}) => {
    return (
        <section className='py-8'>
            <div className="py-8 relative">
                <img src={image} alt="Estudantes" className='w-full h-full object-cover absolute left-0 top-0 -z-10 md:hidden block' />
                
                <div className="relative px-4 md:px-10 max-w-[1100px] xl:max-w-[1300px] 2xl:max-w-[1400px] mx-auto">
                    <DetailAbout className='w-full object-contain object-left h-full absolute -left-16 -top-8 hidden xl:block' />

                    <div className="relative mx-auto w-full md:h-[300px] lg:h-[350px] 2xl:h-[400px] overflow-hidden"
                        style={{
                            maskImage: `url(${maskImage})`,
                            WebkitMaskImage: `url(${maskImage})`,
                            maskSize: '100% 100%',
                            WebkitMaskSize: '100% 100%',
                            maskPosition: 'center bottom',
                            WebkitMaskPosition: 'center bottom',
                        }}
                    >
                        <img src={image} alt="Estudantes" className='w-full h-full object-cover absolute left-0 top-0 -z-10 hidden md:block' />

                        <div className="max-w-screen-md xl:max-w-screen-lg mx-auto h-full flex items-center justify-center lg:justify-start">
                            <div className="bg-white/90 p-8 font-semibold text-sm max-w-96 rounded-xl">
                                As feiras de profissões UNIEXPO proporcionam o encontro entre os futuros universitários e as instituições de ensino superior. 
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-screen-lg mx-auto px-4">
                {content &&
                    <div className="mt-8 text-sm 2xl:text-base" dangerouslySetInnerHTML={{ __html: content }} />
                }
            </div>
        </section>
    );
};

export default FeiraProfissoes;